import { Events, OrcaPropTypes } from "./constants";
import { OrcaApi } from "./OrcaApi";
import { generateUniqueID } from "./uniqueId";
import { getOrcaProps } from "./utils";

// Create a class for the element
export class OrcaPlayer extends HTMLElement {
  static observedAttributes = OrcaPropTypes.map(prop => prop.name);

  constructor() {
    super();
    this.uniqueId = generateUniqueID();
  }

  connectedCallback() {
    window.OrcaPlayer = window.OrcaPlayer || new OrcaApi();
    window.OrcaPlayer.render(this, getOrcaProps(this), this.uniqueId);
  }

  attributeChangedCallback() {
    const newProps = getOrcaProps(this);
    window.orcas[this.uniqueId] = newProps;
    const event = new CustomEvent(Events.PROPS_UPDATED, {
      detail: {
        id: this.uniqueId,
        props: newProps
      }
    });
    window.dispatchEvent(event);
  }
}

customElements.get("orca-player") ||
  customElements.define("orca-player", OrcaPlayer);
